module.exports = __webpack_public_path__ + "img/img-7.35507a79.jpg";